import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectCreatedFolderId,
  selectFolderCreationError,
  selectLoadTemplatesError,
  selectSaveTargetFolders,
  selectTemplates,
} from './template.selectors';

@Injectable({ providedIn: 'root' })
export class TemplateSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly templates = this._store.selectSignal(selectTemplates);

  public readonly loadTemplatesError = this._store.selectSignal(
    selectLoadTemplatesError,
  );

  /** Narrower than `templates` — only folders the buyer may save into. */
  public readonly saveTargetFolders = this._store.selectSignal(
    selectSaveTargetFolders,
  );

  public readonly folderCreationError = this._store.selectSignal(
    selectFolderCreationError,
  );

  public readonly createdFolderId = this._store.selectSignal(
    selectCreatedFolderId,
  );
}
